import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useMemoizedFn, useRequest } from "ahooks";
import { Container, GameItem, AwardBox, Recharge, PackagePage } from "@/views/component/modal/style";
import Button from "@/views/component/public/button";
import { EButton, EModal, EModalTitle } from "@/interface/enum";
import { ConfDoEntrys, Res } from "@/interface/request.interface";
import { catchModal, defaultGameImgUrl, filterMonthGame, playGame } from "@/utils/util";
import { $ajax } from "@/utils/request";
import { useMobx } from "@/utils/hooks";
import { usePages } from "nicetoolfn";
import Interface from "@/interface/public";

export type IProps = {
  modalType: EModal
  message?: string
  titleType?: EModalTitle
  btnType?: EButton
  confirmFn?: Function
  [key: string]: any
}

type TSelectGame_Other = { game: ConfDoEntrys['gs'], index: number }
type IProps_GameList = {
  gameList: ConfDoEntrys['gs'][],
  handleData: (data: TSelectGame_Other) => void
  [key: string]: any
}
export type IRecentPlayGs = {
  gameId: string, playTime: string, serverId: string
}
type IPropsPackage = {
  other: {
    params: [string, Interface.KeyVal],
    type: 0 | 1 | 2 // 0:折扣领取记录  1：折扣赠送记录  2：背包活动记录
  }
}

export function Award(props: { awardImg: string, name: string }) {
  const { name, awardImg } = props;
  return <AwardBox>
    <img src={awardImg} alt=""/>
    <p>{name}</p>
  </AwardBox>
}

function RechargeArea() {
  const store = useMobx('store');
  const [list, triggerList] = useState<IRecentPlayGs[]>([]);
  const [pageIdx, pageCount, table, handleChangePage] = usePages(9, list);
  const { runAsync: runAsync_01, loading } = useRequest(() => $ajax<IRecentPlayGs[]>('//task3game.yy.com/act/recentPlayGs.do', {
    data: {
      act: CONFIG.code.YYVIP2022_free_01, // 活动代号
      innerRef: store.urlParams.HD[0], // 埋点字符
      lastDayNum: 30, //	最近多少天参与游戏（天）
    },
    dataType: 'jsonp'
  }), {
    manual: true,
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    }
  });

  const init = useMemoizedFn(async () => {
    const res1 = await runAsync_01();
    const list = filterMonthGame(res1);
    triggerList(list);
  })

  useEffect(() => {
    init();
  }, [])

  const handleTogglePage = useMemoizedFn((index: number) => {
    if (index > pageCount || index <= 0) {
      return;
    }
    handleChangePage(index);
  })

  const handlePlayGame = useMemoizedFn((index: number) => {
    const item = table[index];
    playGame(item.gameId, item.serverId);
  })

  return <Recharge>
    <div className="content">
      {loading && <div className="loading">加载中...</div>}
      {!loading && list.length === 0 && <div className="loading">无数据</div>}
      {!loading && list.length !== 0 && <>
        <ul>
          {table.map((item, index) => {
            return <li key={index} onClick={() => handlePlayGame(index)}>
              <span>{game_ext[item.gameId].gameName}</span>
              <span className='server'>{item.serverId}</span>
            </li>
          })}
        </ul>
        {list.length > 8 && <div className='page'>
          <span onClick={() => handleTogglePage(pageIdx - 1)}>上一页</span>
          {pageIdx}/{pageCount}
          <span onClick={() => handleTogglePage(pageIdx + 1)}>下一页</span>
        </div>}
      </>}
    </div>
    <div className="tip">
      <div>
        {CONFIG.rechargeRule.map((item: string, index: number) => {
          return <p dangerouslySetInnerHTML={({ __html: item })} key={index}/>
        })}
      </div>
    </div>
  </Recharge>
}

// 背包
function PackageTableList(props: {
  type: IPropsPackage['other']['type'],
  list: any[],
  emitResetTable: () => void
}) {
  const { type, list, emitResetTable } = props;
  const [table, triggerTable] = useState(list);

  useLayoutEffect(() => {
    triggerTable([...list]);
  }, [list])

  /** 折扣-领取记录 ****************************************************************************** */
    // 折扣-领取记录-领取
  const { runAsync: getAward } = useRequest((params) => $ajax(`http://hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/receivegift`, params, true), {
      manual: true,
      onFinally(params, data, er) {
        const res = er === undefined ? data : JSON.parse(er.message);
        if (res.result == true) {
          // 更新列表

          setTimeout(() => {
            emitResetTable();
          }, 300);
          // const idx = table.findIndex((item) => item.giftId === params[0].actPrizeId);
          // table[idx].status = 2;
          // triggerTable([...table]);
          return
        }
        alert(res.desc || '未知错误.');
      }
    });
  const { runAsync: presentAward } = useRequest((params) => $ajax(`http://hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/sendconfirm`, params, true), {
    manual: true,
    onFinally(params, data, er) {
      const res = er === undefined ? data : JSON.parse(er.message);
      if (res.result == true) {
        if (window.confirm(`确定送给${res.data} 吗？\n若被对方拒绝赠送奖品不会返回原赠送者`) == true) {
          const tableRow = table.find((item) => item.editVal != '');
          let data: any;
          $ajax(`http://hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/sendgift`, {
            data: {
              drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
              actPrizeId: tableRow.giftId,
              toimid: tableRow.editVal
            },
            dataType: 'jsonp'
          }, true)
            .then((res) => {
              data = res;
            })
            .catch((e) => {
              data = JSON.parse(e.message);
            })
            .finally(() => {
              if (data?.result == true) {
                alert('赠送成功，通知对方到本页面的【赠送记录】中领取吧。');
                emitResetTable();
                return;
              }
              alert(data?.desc || '未知错误..');
            })
          return
        }
        return
      }
      alert(res.desc || '未知错误.');
    }
  });

  // 折扣-领取记录-领取
  const handleGetAward = useMemoizedFn((index: number) => {
    const award = list[index];
    getAward({
      data: {
        drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
        actPrizeId: award.giftId
      },
      dataType: 'jsonp'
    })
  })

  // 折扣-领取记录-赠送
  const handlePresent = useMemoizedFn((index: number, on_off: boolean) => {
    table.forEach((item) => {
      item.isEdit = false;
      item.editVal = '';
    })

    on_off && (table[index].isEdit = true);

    triggerTable([...table]);
  })

  // 折扣-领取记录-输入框
  const handleIpt = useMemoizedFn((e, index) => {
    table[index].editVal = e.target.value;
    triggerTable([...table]);
  })

  // 折扣-领取记录-确认
  const handleConfirmRecipient = useMemoizedFn((e: any, index: number) => {
    const { editVal, giftId } = table[index];
    if (editVal == undefined || editVal.length == 0 || !(null == editVal.match(/\D/))) {
      alert('请输入正确YY号');
      return;
    }
    presentAward({
      data: {
        drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
        toimid: editVal
      },
      dataType: 'jsonp'
    })
  })
  /** 折扣-赠送记录 ****************************************************************************** */
  const { runAsync: reslovePresentAward } = useRequest((params) => $ajax(`http://hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/acceptgift`, params, true), {
    manual: true,
    onFinally(params, data, er) {
      const res = er === undefined ? data : JSON.parse(er.message);
      if (res.result == true) {
        setTimeout(() => {
          emitResetTable();
        }, 300);
        return;
      }
      alert(res.desc || '未知错误.');
    }
  });
  const { runAsync: rejectPresentAward } = useRequest((params) => $ajax(`http://hd.vip.yy.com/service/hdplatform/drawgift/${CONFIG.discount.YYVIPACTCODE}/refusegift`, params, true), {
    manual: true,
    onFinally(params, data, er) {
      const res = er === undefined ? data : JSON.parse(er.message);
      if (res.result == true) {
        setTimeout(() => {
          emitResetTable();
        }, 300);
        return;
      }
      alert(res.desc || '未知错误.');
    }
  });
  // 折扣-赠送记录-领取
  const handleReslovePresent = useMemoizedFn((index: number) => {
    const award = table[index];
    reslovePresentAward({
      data: {
        drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
        actPrizeId: award.giftId
      },
      dataType: 'jsonp'
    })
  })
  // 折扣-赠送记录-拒绝
  const handleRejectPresent = useMemoizedFn((index: number) => {
    const award = table[index];
    rejectPresentAward({
      data: {
        drawGiftGroupId: CONFIG.discount.YYVIPDRAWGIFTGROUPID,
        actPrizeId: award.giftId
      },
      dataType: 'jsonp'
    })
  })

  return <>
    {/*折扣-领取记录*/}
    {type === 0 && table.map((item, index) => {
      return <li key={index + item.giftName}>
        <div>{item.giftName}</div>
        <div>{item.time}</div>
        {[0].includes(item.status) && <div>
          {item.isEdit && <>
            <input placeholder='请输入YY号' type="text"
                   value={item.editVal}
                   onChange={(e) => handleIpt(e, index)}
            />
            <span onClick={(e) => handleConfirmRecipient(e, index)}>确定</span>
            <span onClick={() => handlePresent(index, false)}>取消</span>
          </>}
          {!item.isEdit && <>
            <span onClick={() => handleGetAward(index)}>领取</span>
            <span onClick={() => handlePresent(index, true)}>赠送</span>
          </>}
        </div>}
        {[2].includes(item.status) && <div>已领取</div>}
        {[1, 3, 4].includes(item.status) && <div>已赠送(yy:{item.toImid})</div>}
      </li>
    })}
    {/*折扣-赠送记录*/}
    {type === 1 && table.map((item, index) => {
      return <li key={index}>
        <div>{item.fromImid}</div>
        <div>{item.giftName}</div>
        <div>
          {[1].includes(item.status) && <>
            <span onClick={() => handleReslovePresent(index)}>领取</span>
            <span onClick={() => handleRejectPresent(index)}>拒绝</span>
          </>}
          {[3].includes(item.status) && '已领取'}
          {[4].includes(item.status) && '已拒绝'}
        </div>
      </li>
    })}
    {/*背包-领取记录*/}
    {type === 2 && table.map((item, index) => {
      item.dispenseResult = item?.dispenseResult === 'null' ? '' : item?.dispenseResult;
      const info = item?.dispenseResult !== 'null'
      return <li key={index}>
        <div>{item.awardName}</div>
        <div>{item.createTime && f2eGame.util.formaDate(item.createTime, 'MM.dd hh:mm')}</div>
        <div>{item.dispenseResult || '已发放到您的账户中'}</div>
      </li>
    })}
  </>
}

function Package(props: IPropsPackage) {
  const pageSize = 3;
  const { params, type } = props.other;
  const [list, triggerList] = useState<any[]>([]);
  const [pageIdx, pageCount, table, handleChangePage] = usePages(pageSize, list);
  const { runAsync, loading } = useRequest(() => $ajax<any>(...params), {
    loadingDelay: 300,
    manual: true,
    onFinally(params, data, e) {
      const res: any = e !== undefined && JSON.parse(e.message);
      let record = [];
      switch (type) {
        case 0:
          record = e === undefined ? data.giftRecords : [];
          record.forEach((item: any) => {
            item['editVal'] = '';
            item['isEdit'] = false
          })
          break;
        case 1:
          if (e === undefined) {
            record = data;
          } else if (res.result === true) {
            record = res.data;
          }
          break;
        case 2:
          record = e === undefined ? data : [];
          break;
      }
      triggerList(record);
    }
  });

  useEffect(() => {
    runAsync();
  }, [])

  const handleTogglePage = useMemoizedFn((index: number) => {
    if (index > pageCount || index <= 0) {
      return;
    }
    handleChangePage(index);
  })
  const resetTable = useMemoizedFn(() => {
    runAsync();
  })

  const TableHead = useMemo(() => {
    switch (type) {
      case 0: // 折扣-领取记录
        return <li>
          <div>奖品名称</div>
          <div>奖品时间</div>
          <div>奖励详情</div>
        </li>
      case 1: // 折扣-赠送记录
        return <li>
          <div>赠送人</div>
          <div>奖品名称</div>
          <div>状态</div>
        </li>
      case 2:
        return <li>
          <div>奖品名称</div>
          <div>奖品时间</div>
          <div>奖励详情</div>
        </li>
      default:
        return <li>
          <div>奖品名称</div>
          <div>奖品时间</div>
          <div>奖励详情</div>
        </li>
    }
  }, [type])

  return <PackagePage>
    <ul>
      {TableHead}
      {loading && <li className="none">加载中...</li>}
      {!loading && table.length === 0 && <li className="none">无记录</li>}
      {!loading && table.length !== 0 && <PackageTableList type={type} list={table}
                                                           emitResetTable={resetTable}
      />}
    </ul>
    <button onClick={() => handleTogglePage(pageIdx - 1)}>上一页</button>
    <span>{pageIdx} / {pageCount || 1}</span>
    <button onClick={() => handleTogglePage(pageIdx + 1)}>下一页</button>
  </PackagePage>
}

export function Modal(props: IProps) {
  let {
    modalType,
    message, children,
    titleType, btnType,
    confirmFn,
    other
  } = props;

  const [data, triggerData] = useState<any>();

  switch (modalType) {
    case EModal['提示']:
      message = !!children && !!message ? '未知错误' : message;
      titleType = titleType || EModalTitle['提示'];
      break;
    case EModal['恭喜获得']:
      titleType = titleType || EModalTitle['恭喜获得'];
      break;
    case EModal['领取记录']:
      titleType = titleType || EModalTitle['领取记录'];
      break;
    case EModal['充值区服']:
      titleType = titleType || EModalTitle['充值区服'];
      break;
    case EModal['赠送记录']:
      titleType = titleType || EModalTitle['赠送记录'];
      break;
    default:
      titleType = titleType || EModalTitle['提示'];
      break;
  }

  btnType = btnType || EButton['弹窗-确定']

  return <>
    <Container modalType={modalType} titleType={titleType}>
      <div className="closeIcon" onClick={() => props.clearAll()}/>
      <div className="title"/>
      {[EModal['提示'], EModal['恭喜获得']].includes(modalType) && <>
        <div className="disTable">
          {children && <div className="disTableCell">{children}</div>}
          {!children && message && <div className="disTableCell" dangerouslySetInnerHTML={({ __html: message })}/>}
        </div>
        <Button type={btnType as EButton} onClick={() => {
          confirmFn && confirmFn(props)
          !confirmFn && props.clearAll()
        }}/>
      </>}

      {[EModal['充值区服']].includes(modalType) && <RechargeArea/>}

      {[EModal['领取记录'], EModal['赠送记录']].includes(modalType) && <Package other={other}/>}
    </Container>
  </>
}

